












export default {
    name: "TextSettingChecker",
    props: {
        setting: String,
        text: String,
        required: Boolean,
        closingTag: Boolean,
    },
    computed: {
        cssClass() {
            //@ts-ignore
            if (_.includes(this.text, this.setting)) {
                return "text-success";
            } else if (this.required) {
                return "text-danger";
            } else {
                return "text-muted";
            }
        },
    },
};
